// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.middle_price_offer {
  background-color: #d2b356;
  color: #fff;
  padding: 25px;
}

.normal_price_offer {
  background: #f5f5f5;
  padding: 25px;
  box-shadow: gray;
}

.box_shaddow_offer:hover {
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.title_offer_after {
  background: #d2b356;
  width: 30px;
  height: 5px;
  margin-bottom: 10px;
}

.simple_line {
  background: #d2b356;
  display: block;
  width: 100%;
  height: 2px;
  margin-top: 10px;
}

.close-btn {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5rem;
  font-size: 1.5rem;
  color: #000;
  background-color: transparent;
  border: none;
  z-index: 1000;
}

.image-container {
  width: 100%; /* Ensure all containers have the same width */
}

.image-container img {
  width: 100%;
  height: auto;
  display: block;
  transition: box-shadow 0.3s ease, transform 0.3s ease; /* Add transition for smooth shadow effect */
}

.image-container:hover img {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4); /* Add shadow effect on hover */
  cursor: pointer; /* Change cursor to pointer on hover */
}

.gold-overlay {
  position: relative;
  display: inline-block;
  overflow: hidden;
}

.gold-overlay::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: gold; /* Change this to your desired gold color */
  mix-blend-mode: color; /* This mode blends the gold color with the underlying black */
  z-index: 1;
}

.gold-overlay img {
  display: block;
  width: 35px; /* Adjust the width to make the icons smaller */
  height: auto;
  margin: 0 auto; /* Center the icons horizontally */
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/app/offer-page/offer-page.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAGA;EACI,mBAAA;EACA,aAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,0CAAA;AAAJ;;AAGA;EACE,mBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AAAF;;AAGA;EACI,mBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;AAAJ;;AAOA;EACI,WAAA,EAAA,8CAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,qDAAA,EAAA,4CAAA;AAJJ;;AAOA;EACI,wCAAA,EAAA,+BAAA;EACA,eAAA,EAAA,sCAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA,EAAA,2CAAA;EACA,qBAAA,EAAA,8DAAA;EACA,UAAA;AAJJ;;AAOA;EACI,cAAA;EACA,WAAA,EAAA,+CAAA;EACA,YAAA;EACA,cAAA,EAAA,kCAAA;EACA,UAAA;AAJJ","sourcesContent":[".middle_price_offer{\r\n    background-color: #d2b356;\r\n    color: #fff;\r\n    padding: 25px;\r\n    \r\n}\r\n\r\n.normal_price_offer{\r\n    background: #f5f5f5;\r\n    padding: 25px;\r\n    box-shadow: gray;\r\n}\r\n\r\n.box_shaddow_offer:hover{\r\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.title_offer_after {\r\n  background: #d2b356;\r\n  width: 30px;\r\n  height: 5px;\r\n  margin-bottom: 10px;\r\n} \r\n\r\n.simple_line {\r\n    background: #d2b356;\r\n    display: block;\r\n    width: 100%;\r\n    height: 2px;\r\n    margin-top: 10px;\r\n  } \r\n\r\n.close-btn {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    padding: 0.5rem;\r\n    font-size: 1.5rem;\r\n    color: #000;\r\n    background-color: transparent;\r\n    border: none;\r\n    z-index: 1000;\r\n}\r\n\r\n.modal-body {\r\n}\r\n\r\n\r\n.image-container {\r\n    width: 100%; /* Ensure all containers have the same width */\r\n}\r\n\r\n.image-container img {\r\n    width: 100%;\r\n    height: auto;\r\n    display: block;\r\n    transition: box-shadow 0.3s ease, transform 0.3s ease; /* Add transition for smooth shadow effect */\r\n}\r\n\r\n.image-container:hover img {\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4); /* Add shadow effect on hover */\r\n    cursor: pointer; /* Change cursor to pointer on hover */\r\n}\r\n\r\n.gold-overlay {\r\n    position: relative;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n}\r\n\r\n.gold-overlay::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: gold; /* Change this to your desired gold color */\r\n    mix-blend-mode: color; /* This mode blends the gold color with the underlying black */\r\n    z-index: 1;\r\n}\r\n\r\n.gold-overlay img {\r\n    display: block;\r\n    width: 35px; /* Adjust the width to make the icons smaller */\r\n    height: auto;\r\n    margin: 0 auto; /* Center the icons horizontally */\r\n    z-index: 2;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
